// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__rdOKs","codes":"styles_codes__o5RHt","codes_list":"styles_codes_list__Ir4hX"};